import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { servicios_grupogack_catalogo, tipo_domicilio } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';


import tipodomjson from '../../../../../Datos/tipoDomicilio.json';

const TiposDomicilio = ({ id, permisos }) => {

    const [tiposDomicilio, setTiposDomicilio] = useState(null);

    useEffect(() => {
        /*
        Axios.get(`${servicios_grupogack_catalogo}s/tipos/domicilio/all`, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:*/
                    console.log(tipodomjson);
                    setTiposDomicilio(tipodomjson);
                    /*break;
                case 404:
                    setTiposDomicilio([]);
                    break;
                default:
                    alert('error');
                    break;
            }
        })
        .catch(error => alert('error'));*/
    },[]);

    return (
        <div id={ id }>
            {   
                tiposDomicilio
                ?   <DataTableService id={id} title={ tipo_domicilio }
                        columns={[
                            { field: "tipodomNom", title: "Nombre" },
                        ]}
                        data={tiposDomicilio}
                        permisos={permisos}
                    />
                :   <SpinnerOval />
            }
        </div>
    );
}
 
export default TiposDomicilio;
